var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'full_layout':_vm.show_full_layout},attrs:{"id":"full-flyout"}},[_c('div',{staticClass:"heading"},[_c('b-row',{staticClass:"pt-3 pb-3 pl-3 pr-3"},[_c('b-col',[_vm._t("page-content")],2)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }